import {DumpsterFire} from "../../DumpsterFire";
import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../core/reel/winpresentation/SimplePresentationRunner";
import {DumpsterFireGameData, DumpsterFireInitData} from "../../server/DumpsterFireData";
import {ISymbol} from "../../../core/reel/simplereel/IReelData";
import {IBetWayWinData} from "@nolimitcity/slot-game/bin/utils/server/IData";
import {gsap, TimelineLite} from "gsap";
import {DumpsterFireSymbol, SYMBOL_NAME} from "../../reels/DumpsterFireSymbol";
import {DumpsterFireGameMode} from "../../server/DumpsterFireGameMode";
import {DFGameConfig} from "../../DFGameConfig";
import {DumpsterFireSound} from "../../sound/DumpsterFireSound";

export class DFWinHighlightRunner implements SimplePresentation {
    private _mainTl: TimelineLite = new TimelineLite();
    private _pointArray: number[][] = [];

    shouldRun(): boolean {
        return DumpsterFire.model.gameData.scatterWins.length > 0;
    }

    private playHighlightSounds(): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        tl.add(() => {
            DumpsterFire.soundPlayer.playSound(DumpsterFireSound.BETLINE_AIM);
            DumpsterFire.soundPlayer.playSound(DumpsterFireSound.BETLINE_AIM_LOAD);
        }, 0);
        return tl;
    }

    start(controller: SimplePresentationRunnerController) {
        this._mainTl = new TimelineLite({
            delay: 0.2,
            onStart: () => {
                DumpsterFire.winMultiView.removeAllSprites();
                this._mainTl.add(DumpsterFire.reelAnticipation.hideContainer(), 0);
            },
            onComplete: () => {
                DumpsterFire.winView.removeMovedMulti();
                this._pointArray = [];
                if ((DumpsterFire.model.gameData.scatterWins.length > 0 || DumpsterFire.model.isXBombPresent) && (DumpsterFire.model.data.nextMode === DumpsterFireGameMode.NORMAL || DumpsterFire.model.data.nextMode === DumpsterFireGameMode.EXTRA_SPIN)) {
                    DumpsterFire.winView.removeWinNumbers();
                    DumpsterFire.winView.playNormalAnimationForAll();
                }
                // DumpsterFire.winView.removeMovedMulti();
                controller.finish();
            }
        });
        DumpsterFire.model.gameData.scatterWins;
        if (DumpsterFire.model.boostedBetName.indexOf("BOOSTED_BET_STATE_") > -1) {
            DumpsterFire.model.isNotNoWinRound = true;
        }
        this._mainTl.add(() => {
            controller.setSkipCallback(() => this.onSkip());
        }, 0.001);
        const winTl: TimelineLite = new TimelineLite(),
            gameData: DumpsterFireInitData | DumpsterFireGameData = DumpsterFire.model.data;
        let delay: number = 21 / 30;

        for (let winGroup: number = 0; winGroup < gameData.scatterWins.length; winGroup++) {
            const groupWin: IBetWayWinData = gameData.scatterWins[winGroup],
                allWinPositions: boolean[][] = DumpsterFire.model.calculateWinPositions(groupWin);
            const winNumPlayPosition: [number, number] = this.findLastNoWildSymbolPosition(groupWin);
            const winNumPlaySecondPosition: [number, number] = this.findLastNoWildSymbolPosition(groupWin);

            let offset: number = winGroup;
            if (gameData.scatterWins[winGroup].symbol === "L1" && !DumpsterFire.model.explodeSound.includes("betlineShotDucks")) {
                DumpsterFire.model.explodeSound.push("betlineShotDucks");
            } else if (gameData.scatterWins[winGroup].symbol === "L4" && !DumpsterFire.model.explodeSound.includes("betlineShotBottles")) {
                DumpsterFire.model.explodeSound.push("betlineShotBottles");
            } else if (gameData.scatterWins[winGroup].symbol === "L5" && !DumpsterFire.model.explodeSound.includes("betlineShotCans")) {
                DumpsterFire.model.explodeSound.push("betlineShotCans");
            }

            let lastWinGroup: boolean = (winGroup === gameData.scatterWins.length - 1);
            winTl.add(this.playGroupWin(allWinPositions, winGroup, lastWinGroup), delay * offset);
            groupWin.reelWinPositions.forEach((reelWin: boolean[], reelId: number) => {
                reelWin.forEach((winPos: boolean, rowId: number) => {
                    if (winPos) {
                        if (reelId === winNumPlayPosition[0] && rowId === winNumPlayPosition[1]) {
                            winTl.add(() => {
                                DumpsterFire.winView.playWinNumbers(groupWin, false, winNumPlayPosition, winNumPlaySecondPosition);
                            }, delay * offset);
                        }
                    }
                });
            });
            winTl.to(this, {duration: 0.2});
        }
        this._mainTl.add(winTl, 0);
        this._mainTl.to(this, {duration: 0.2});
    };

    public findLastNoWildSymbolPosition(betWayWinData: IBetWayWinData): [number, number] {
        for (let reelId = 0; reelId < DFGameConfig.totalReels; reelId++) {
            for (let symId = 0; symId < DumpsterFire.model.data.reels[reelId].length; symId++) {
                if (!betWayWinData.reelWinPositions[reelId][symId]) {
                    continue;
                }
                let sym: ISymbol = DumpsterFire.allReelsView.getSymbolAtPosition(reelId, symId);
                if (!sym) {
                    continue;
                }

                if (DumpsterFire.model.data.reels[reelId][symId] === SYMBOL_NAME.WILD) {
                    continue;
                }
                if (this._pointArray.includes([reelId + 1, symId]) || this._pointArray.includes([reelId - 1, symId])) {
                    continue;
                }
                this._pointArray.push([reelId, symId]);
                return [reelId, symId];
            }
        }
        return [0, 0];
    }

    private playGroupWin(betWayWin: boolean[][], winGroupNumber: number, lastWinGroup: boolean): gsap.core.Timeline {
        const tl: gsap.core.Timeline = new gsap.core.Timeline();
        let isPlayed = false;
        for (let reelId: number = 0; reelId < DumpsterFire.model.gameData.evaluatedReels.length; reelId++) {
            for (let rowId: number = 0; rowId < DumpsterFire.model.gameData.evaluatedReels[reelId].length; rowId++) {
                const symbol: ISymbol = DumpsterFire.allReelsView.getSymbolAtPosition(reelId, rowId);
                const toSymbol: string = DumpsterFire.model.gameData.evaluatedReels[reelId][rowId];
                let symPos: number = DFGameConfig.totalReels * reelId + rowId,
                    multiValue: number = (DumpsterFire.model.data.positionMultipliers[reelId][rowId]) / 2;
                if (betWayWin[reelId][rowId]) {
                    if (DumpsterFire.model.hitMaxMulti.includes(symPos) || DumpsterFire.model.isMaxMulti.includes(symPos)) {
                        multiValue = 8192;
                    }
                    if (!isPlayed) {
                        tl.add(() => {
                            this.playHighlightSounds();
                        }, 0);
                        isPlayed = true;
                    }
                    if (DumpsterFire.model.data.reels[reelId][rowId] === SYMBOL_NAME.WILD) {
                        tl.add(lastWinGroup ? DumpsterFire.winView.playWinAnimation(<DumpsterFireSymbol>symbol) : DumpsterFire.winView.playIdleAnimation(<DumpsterFireSymbol>symbol), 0);
                    } else {
                        tl.add(DumpsterFire.winView.playWinAnimation(<DumpsterFireSymbol>symbol, toSymbol), 0);
                    }
                    tl.add(DumpsterFire.allReelsView.showWinMultipliers(reelId, rowId, multiValue), 0);
                } else {
                    const shouldPlayNoWinAnimation: boolean = winGroupNumber === 0 ||
                        (winGroupNumber !== 0 && !DumpsterFire.model.allExplodeWinPositions[reelId][rowId]);
                    if (shouldPlayNoWinAnimation) {
                        tl.add([DumpsterFire.winView.playNoWinAnimation(<DumpsterFireSymbol>symbol, toSymbol)], 0);
                    }
                }
            }
        }
        return tl;
    }

    private onSkip(): void {
        this._mainTl.timeScale(2);
    }
}